import { useSyncExternalStore } from 'react';

/**
 * Page-level state shared by sibling sections (a search band, its category bar and the list under them).
 * Sections render as separate slots, so they meet here rather than through props. Never written during SSR.
 */
export interface Store<T> {
  get: () => T;
  set: (next: Partial<T>) => void;
  subscribe: (fn: () => void) => () => void;
}

export function createStore<T extends object>(initial: T): Store<T> {
  let value = initial;
  const subs = new Set<() => void>();
  return {
    get: () => value,
    set: (next) => {
      value = { ...value, ...next };
      subs.forEach((fn) => fn());
    },
    subscribe: (fn) => {
      subs.add(fn);
      return () => {
        subs.delete(fn);
      };
    },
  };
}

export function useStore<T extends object>(store: Store<T>): T {
  return useSyncExternalStore(store.subscribe, store.get, store.get);
}
